"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiTextField = getMuiTextField;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _constants = require("../../../constants");
/* eslint-disable sort-keys */

function getMuiTextField() {
  return {
    defaultProps: {
      InputLabelProps: {
        shrink: true
      }
    },
    styleOverrides: {
      root: function (_ref) {
        var ownerState = _ref.ownerState,
          theme = _ref.theme;
        return {
          //textarea
          '&:has(.MuiInputBase-inputMultiline)': {
            '.MuiOutlinedInput-root': {
              padding: '10px 12px'
            }
          },
          //disabled
          '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.gray[300]
          },
          '& .MuiInputBase-input.Mui-disabled': {
            WebkitTextFillColor: theme.palette.gray[500],
            color: theme.palette.gray[500]
          },
          '&:has(.MuiOutlinedInput-root.Mui-disabled)': {
            '.MuiFormHelperText-root': {
              color: "".concat(theme.palette.gray[600], " !important")
            },
            '.MuiOutlinedInput-input': {
              color: theme.palette.gray[500]
            },
            '.MuiOutlinedInput-root': {
              '& fieldset': {
                '& legend': {
                  width: 0
                }
              },
              backgroundColor: theme.palette.gray[50]
            }
          },
          //destructive mode
          '&:has(.MuiOutlinedInput-root.Mui-error)': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.error[500]
            },
            '.MuiFormHelperText-root': {
              color: theme.palette.error[600]
            },
            '.MuiInputAdornment-root-positionEnd': {
              color: theme.palette.error[500]
            },
            '.MuiOutlinedInput-root': {
              borderColor: theme.palette.error[500]
            }
          },
          //focused
          '&:has(.MuiOutlinedInput-root.Mui-error.Mui-focused)': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.error[300],
              boxShadow: "0px 0px 0px 4px ".concat(theme.palette.error[100])
            }
          },
          '&:has(.MuiOutlinedInput-root.Mui-focused)': {
            '& .MuiOutlinedInput-input': {
              color: theme.palette.gray[900]
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.primary[300],
              boxShadow: "0px 0px 0px 4px ".concat(theme.palette.primary[100], ", 0px 1px 2px 0px rgba(16, 24, 40, 0.05)")
            },
            '.MuiOutlinedInput-root': {
              borderColor: theme.palette.primary[300],
              boxShadow: "0px 0px 0px 4px ".concat(theme.palette.primary[100], ", 0px 1px 2px 0px rgba(16, 24, 40, 0.05)")
            }
          },
          '.MuiFormHelperText-root': (0, _extends2["default"])({}, theme.typography['text-sm-regular'], {
            color: theme.palette.gray[600],
            margin: 0
          }),
          '.MuiInputAdornment-positionEnd': {
            color: theme.palette.gray[400]
          },
          '.MuiInputAdornment-positionStart': {
            color: theme.palette.gray[500]
          },
          '.MuiOutlinedInput-input': (0, _extends2["default"])({}, theme.typography['text-md-regular'], {
            '&::placeholder': {
              color: theme.palette.gray[500],
              opacity: 1
            },
            color: theme.palette.gray[900],
            height: '24px',
            padding: 0
          }),
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.gray[400]
          },
          '.MuiOutlinedInput-root': {
            '& .Mui-readOnly': {
              cursor: 'default'
            },
            '&.Mui-readOnly': {
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: "".concat(theme.palette.gray[100], " !important"),
                borderWidth: '1px !important',
                boxShadow: 'none !important'
              },
              backgroundColor: "".concat(theme.palette.gray[25], " !important"),
              borderColor: "".concat(theme.palette.gray[100], " !important"),
              boxShadow: 'none !important',
              outlineColor: "".concat(theme.palette.gray[100], " !important")
            },
            '&:hover fieldset': {
              borderColor: ownerState.disabled ? theme.palette.gray[300] : theme.palette.gray[600]
            },
            backgroundColor: theme.palette.common.white,
            border: 'none',
            borderColor: theme.palette.gray[400],
            borderRadius: '8px',
            borderWidth: '1px',
            boxShadow: theme.shadows[_constants.SHADOWS.xs],
            gap: 0,
            padding: '10px 14px'
          },
          '.MuiSelect-icon': {
            display: 'none'
          },
          '.MuiSelect-select': {
            display: 'flex'
          },
          gap: '6px',
          width: '320px'
        };
      }
    },
    variants: [{
      props: {
        size: 'sm'
      },
      style: function () {
        return {
          '.MuiOutlinedInput-root': {
            padding: '8px 12px'
          }
        };
      }
    }, {
      props: {
        size: 'md'
      },
      style: function () {
        return {
          '.MuiOutlinedInput-root': {
            padding: '10px 14px'
          }
        };
      }
    }]
  };
}